import { useState } from 'react';
import { Account } from 'api/account';
import { User } from 'api/models';
import { fullName } from 'utils/full-name';
import { isLocalhost } from 'utils/is-localhost';
import { isNitroEnvironment, isOrbitsEnvironment } from 'utils/is-nitro-env';

declare global {
  interface Window {
    zapscale: any;
  }
}

const isPermittedAccount = (account: Account): boolean => {
  return [
    357, // Chargebee
    1779, // Clari
    181, // Net core
    174, // Posist
  ].includes(account.accountId);
};

const initZapScaleForVendor = (account: Account, user: User) => {
  if (
    isLocalhost() ||
    (!(isNitroEnvironment() || isOrbitsEnvironment()) &&
      !isPermittedAccount(account))
  ) {
    return;
  }
  window.zapscale.init(
    '6446c4caa5ce494efe6558e7',
    {
      product_name: 'Rocketlane',
      organization_id: account.accountId,
      organization_name: account.accountName,
      unique_organization_id: account.accountId,
      user_id: user.userId,
      user_name: fullName(user),
      user_email: user.emailId,
      role_id: user.role?.roleId,
      role_name: user.role?.roleName,
    },
    {
      development: isNitroEnvironment() || isOrbitsEnvironment(),
    },
  );
};

export const useZapScaleVendorInitialiser = () => {
  const [initialised, setInitialised] = useState(false);

  return (account: Account, user: User) => {
    if (!initialised) {
      setInitialised(true);
      initZapScaleForVendor(account, user);
    }
  };
};
